var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsFlag1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V13H0",
    fill: "#B31942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.57628e-07 1.5H24ZM24 3.5H-3.57628e-07ZM-3.57628e-07 5.5H24ZM24 7.5H-3.57628e-07ZM-3.57628e-07 9.5H24ZM24 11.5H-3.57628e-07Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.57628e-07 1.5H24M24 3.5H-3.57628e-07M-3.57628e-07 5.5H24M24 7.5H-3.57628e-07M-3.57628e-07 9.5H24M24 11.5H-3.57628e-07",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.6V7H0",
    fill: "#0A3161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 0.3L1.02845 1.02361L0.430358 0.576393H1.16964L0.571549 1.02361L0.8 0.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 1.7L1.02845 2.42361L0.430358 1.97639H1.16964L0.571549 2.42361L0.8 1.7Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 3.1L1.02845 3.82361L0.430358 3.37639H1.16964L0.571549 3.82361L0.8 3.1Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 4.5L1.02845 5.22361L0.430358 4.77639H1.16964L0.571549 5.22361L0.8 4.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 5.9L1.02845 6.62361L0.430358 6.17639H1.16964L0.571549 6.62361L0.8 5.9Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 0.999999L1.82845 1.72361L1.23036 1.27639H1.96964L1.37155 1.72361L1.6 0.999999Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 2.4L1.82845 3.12361L1.23036 2.67639H1.96964L1.37155 3.12361L1.6 2.4Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 3.8L1.82845 4.52361L1.23036 4.07639H1.96964L1.37155 4.52361L1.6 3.8Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 5.2L1.82845 5.92361L1.23036 5.47639H1.96964L1.37155 5.92361L1.6 5.2Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0.299999L2.62845 1.02361L2.03036 0.576392H2.76964L2.17155 1.02361L2.4 0.299999Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1.7L2.62845 2.42361L2.03036 1.97639H2.76964L2.17155 2.42361L2.4 1.7Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 3.1L2.62845 3.82361L2.03036 3.37639H2.76964L2.17155 3.82361L2.4 3.1Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 4.5L2.62845 5.22361L2.03036 4.77639H2.76964L2.17155 5.22361L2.4 4.5Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 5.9L2.62845 6.62361L2.03036 6.17639H2.76964L2.17155 6.62361L2.4 5.9Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 0.999999L3.42845 1.72361L2.83036 1.27639H3.56964L2.97155 1.72361L3.2 0.999999Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 2.4L3.42845 3.12361L2.83036 2.67639H3.56964L2.97155 3.12361L3.2 2.4Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 3.8L3.42845 4.52361L2.83036 4.07639H3.56964L2.97155 4.52361L3.2 3.8Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 5.2L3.42845 5.92361L2.83036 5.47639H3.56964L2.97155 5.92361L3.2 5.2Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.299999L4.22845 1.02361L3.63036 0.576392H4.36964L3.77155 1.02361L4 0.299999Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.7L4.22845 2.42361L3.63036 1.97639H4.36964L3.77155 2.42361L4 1.7Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.1L4.22845 3.82361L3.63036 3.37639H4.36964L3.77155 3.82361L4 3.1Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5L4.22845 5.22361L3.63036 4.77639H4.36964L3.77155 5.22361L4 4.5Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.9L4.22845 6.62361L3.63036 6.17639H4.36964L3.77155 6.62361L4 5.9Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0.999999L5.02845 1.72361L4.43036 1.27639H5.16964L4.57155 1.72361L4.8 0.999999Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.4L5.02845 3.12361L4.43036 2.67639H5.16964L4.57155 3.12361L4.8 2.4Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.8L5.02845 4.52361L4.43036 4.07639H5.16964L4.57155 4.52361L4.8 3.8Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 5.2L5.02845 5.92361L4.43036 5.47639H5.16964L4.57155 5.92361L4.8 5.2Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60001 0.299999L5.82846 1.02361L5.23037 0.576392H5.96965L5.37156 1.02361L5.60001 0.299999Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 1.7L5.82845 2.42361L5.23036 1.97639H5.96964L5.37155 2.42361L5.6 1.7Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 3.1L5.82845 3.82361L5.23036 3.37639H5.96964L5.37155 3.82361L5.6 3.1Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4.5L5.82845 5.22361L5.23036 4.77639H5.96964L5.37155 5.22361L5.6 4.5Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5.9L5.82845 6.62361L5.23036 6.17639H5.96964L5.37155 6.62361L5.6 5.9Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39999 0.999999L6.62844 1.72361L6.03035 1.27639H6.76963L6.17154 1.72361L6.39999 0.999999Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 2.4L6.62845 3.12361L6.03036 2.67639H6.76964L6.17155 3.12361L6.4 2.4Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.8L6.62845 4.52361L6.03036 4.07639H6.76964L6.17155 4.52361L6.4 3.8Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 5.2L6.62845 5.92361L6.03036 5.47639H6.76964L6.17155 5.92361L6.4 5.2Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19999 0.299999L7.42844 1.02361L6.83035 0.576392H7.56963L6.97154 1.02361L7.19999 0.299999Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 1.7L7.42845 2.42361L6.83036 1.97639H7.56964L6.97155 2.42361L7.2 1.7Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 3.1L7.42845 3.82361L6.83036 3.37639H7.56964L6.97155 3.82361L7.2 3.1Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 4.5L7.42845 5.22361L6.83036 4.77639H7.56964L6.97155 5.22361L7.2 4.5Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 5.9L7.42845 6.62361L6.83036 6.17639H7.56964L6.97155 6.62361L7.2 5.9Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.999999L8.22845 1.72361L7.63036 1.27639H8.36965L7.77155 1.72361L8 0.999999Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.4L8.22845 3.12361L7.63036 2.67639H8.36964L7.77155 3.12361L8 2.4Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.8L8.22845 4.52361L7.63036 4.07639H8.36964L7.77155 4.52361L8 3.8Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.2L8.22845 5.92361L7.63036 5.47639H8.36964L7.77155 5.92361L8 5.2Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80002 0.299999L9.02847 1.02361L8.43037 0.576392H9.16966L8.57156 1.02361L8.80002 0.299999Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.7L9.02845 2.42361L8.43036 1.97639H9.16964L8.57155 2.42361L8.8 1.7Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 3.1L9.02845 3.82361L8.43036 3.37639H9.16964L8.57155 3.82361L8.8 3.1Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 4.5L9.02845 5.22361L8.43036 4.77639H9.16964L8.57155 5.22361L8.8 4.5Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 5.9L9.02845 6.62361L8.43036 6.17639H9.16964L8.57155 6.62361L8.8 5.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag1);
export default __webpack_public_path__ + "static/media/US-FLAG1.1c77ba2acc0cc3d0f8a03dcedb8481fb.svg";
export { ForwardRef as ReactComponent };